import { KatSpinner } from '@amzn/katal-react';
import React, { FC, MutableRefObject } from 'react';
import styles from './SearchState.module.css';
import { SearchResult } from '@amzn/fire-tv-campaign-automation-service';

export interface SearchStateProps {
  isSearching: boolean;
  searchError?: string;
  searchResults?: SearchResult[];
  queryRef: MutableRefObject<string>;
}

export const SearchState: FC<SearchStateProps> = ({
  isSearching,
  searchError,
  queryRef,
  searchResults,
}) => {
  if (isSearching) {
    return (
      <div className={styles.loadingState}>
        <KatSpinner size="small" className={styles.spinner} />
        <span>Searching for content...</span>
      </div>
    );
  }

  if (searchError || (!!queryRef.current && searchResults && searchResults.length === 0)) {
    return (
      <div className={styles.emptyState}>
        <span>No results found for "{queryRef.current}". Try a different search term.</span>
      </div>
    );
  }

  return null;
};
